var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "600"
    }
  }, [_c('console-title', [_vm.isCreate ? _c('span', [_vm._v("통합뷰어 생성")]) : _c('span', [_vm._v("통합뷰어 상세")])]), _c('console-body', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "아이디",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.username,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "username", $$v);
      },
      expression: "integratedViewer.username"
    }
  }), _c('v-password-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "비밀번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.password,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "password", $$v);
      },
      expression: "integratedViewer.password"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "담당자(이름)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "name", $$v);
      },
      expression: "integratedViewer.name"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "담당자(연락처)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "phone", $$v);
      },
      expression: "integratedViewer.phone"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "담당자(이메일)",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.email,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "email", $$v);
      },
      expression: "integratedViewer.email"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "postcode", $$v);
      },
      expression: "integratedViewer.postcode"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "기본주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "address1", $$v);
      },
      expression: "integratedViewer.address1"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "상세주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "address2", $$v);
      },
      expression: "integratedViewer.address2"
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "ci",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.integratedViewer.ci,
      callback: function callback($$v) {
        _vm.$set(_vm.integratedViewer, "ci", $$v);
      },
      expression: "integratedViewer.ci"
    }
  })], 1), _c('v-card-actions')], 1)], 1), _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }